import { useLayoutEffect, useRef, useState } from "react"
import { useLocation } from "react-router"

import Loading from "consumer/setup/loading";

import listStype from "./list.module.css"
import { convert_time } from "consumer/@@@/convert_time"
import { convert_grade } from "consumer/@@@/convert_grade"
import { get_grade_list } from "consumer/@@@/get_grade_list"
import { get_apply_list } from "../@@@/get_apply_list";


export default function List() {

    const location = useLocation()
    const student_name = location.state['student_name']
    const parent_phone = location.state['parent_phone']

    const isMounted = useRef(0)

    const [applyList, Set_applyList] = useState([])
    const [gradeList, Set_gradeList] = useState([])

    const [loading, Set_loading] = useState(true)

    useLayoutEffect(() => {
        if(isMounted.current === 0) {
            get_apply_list({
                student_name: student_name,
                parent_phone: parent_phone,
                Set_applyList: Set_applyList
            })
            get_grade_list({
                Set_gradeList: Set_gradeList,
                isMounted: isMounted
            })
        }
    }, [])

    useLayoutEffect(() => {
        if(isMounted.current === 1) {
            Set_loading(false)
        }
    }, [gradeList])

    return(
        <>
            <Loading
                loading={loading}
            ></Loading>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBlock: "10px",
                    fontSize: "20px",
                    fontWeight: "bold",
                }}
            >신청한 행사 목록</div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    paddingInline: "10px",
                    boxSizing: "border-box"
                }}
            >
                {applyList
                .map((value, index) => {
                    return(
                        <div
                            key={index}
                            className={listStype['list']}
                        >
                            <div>행사명: {value['Schedule']['Event']['name']}({value['Schedule']['branchName']})</div>
                            <div>행사일: {value['Schedule']['targetDate']} {convert_time(value['Schedule']['targetTime'])}</div>
                            <div>
                                <span>신청일: </span>
                                <span>{function() {
                                    const w = new Date(value['submittedAt'].toString())
                                    const day = w.toLocaleString("ko-KR", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit"
                                    }).replaceAll(". ", "-").replace(".", "")
                                    const time = w.toLocaleString("ko-KR", {
                                        hour: "2-digit",
                                        minute: "2-digit"
                                    }).replace(":", "시 ") + "분"
                                    return `${day} ${time}`
                                }()}</span>
                            </div>

                            <div>학생: {value['studentName']}({value['studentGender']})</div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div>
                                    <span>재원 여부: </span>
                                    <span>{function() {
                                        if(value['isEnrolled']) {
                                            return '재원생'
                                        }
                                        else {
                                            return '비재원생'
                                        }
                                    }()}</span>
                                    <span>({convert_grade({
                                        grade_list: gradeList,
                                        grade: value['studentGrade']
                                    })})</span>
                                </div>
                            </div>

                            <div>
                                <span>결제 상태: </span>
                                <span>{function() {
                                    if(value['paid']) {
                                        return '결제'
                                    }
                                    else {
                                        return '미결제'
                                    }
                                }()}</span>
                                <span>({function() {
                                    if(value['Schedule']['payment'] === 0) {
                                        return '무료'
                                    }
                                    else {
                                        return `${value['Schedule']['payment']}원`
                                    }
                                }()})</span>
                            </div>

                            <div
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    bottom: "10px",
                                    fontSize: "30px",
                                    fontWeight: "bold",
                                    color: "red"
                                }}
                            >마감</div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}